export const ACCOUNT_GROUPING_API_REQUEST="ACCOUNT_GROUPING/GROUPING_API_REQUEST";
export const ACCOUNT_GROUPING_API_SUCCESS="ACCOUNT_GROUPING/GROUPING_API_SUCCESS";
export const ACCOUNT_GROUPING_API_FAILED="ACCOUNT_GROUPING/GROUPING_API_FAILED";
